
















































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import SidebarSwitcher from '@/components/organisms/v2/SidebarSwitcher.vue'
import StudentHistoryHeader from '@/components/organisms/v3/StudentHistoryHeader.vue'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import SelectSubject from '@/components/atoms/SelectSubject.vue'
import SelectPeriod from '@/components/organisms/SelectPeriod.vue'
import ChartLineUnderstandingRelative, { ChartRecord } from '@/components/atoms/ChartLineUnderstandingRelative.vue'
import AccordionStudentHistory, { GradeHistories } from '@/components/organisms/v3/AccordionStudentHistory.vue'
import SubjectSituationWebApi from '@/mixins/historyv3/SubjectSituationWebApi'
import LoadEnableSubjectsApi from '@/mixins/utils/LoadEnableSubjectsApi'
import FilterMode from '@/components/organisms/v3/FilterMode.vue'

@Component({
  components: {
    SidebarSwitcher,
    StudentHistoryHeader,
    ColoredBox,
    ChartLineUnderstandingRelative,
    SelectSubject,
    SelectPeriod,
    AccordionStudentHistory,
    FilterMode,
  },
})
export default class SubjectSituation extends Mixins(SubjectSituationWebApi, LoadEnableSubjectsApi) {
  private selectedSubject = this.$route.query.selectedSubject ? String(this.$route.query.selectedSubject) : ''
  @Prop({ default: false })
  private isLerningPreview!: boolean

  // 教科プルダウン表示対象、教科コードの配列 ex.=> ['su', 'ei', 'ko']
  private enableSubjects: string[] = []

  private selectedTerm = '1week'

  private modeCode = ''

  private handleChangeMode(code: string) {
    this.modeCode = code
  }
  @Watch('modeCode')
  private async watchSelectMode() {
    Vue.prototype.$loading.start()
    await this.loadChartRecords()
    await this.loadGradeHistories()
    Vue.prototype.$loading.complete()
  }

  private get branchId() {
    return Vue.prototype.$cookies.get('dataGdls').branchId
  }

  private get studentUserId() {
    return Vue.prototype.$cookies.get('authGdls').currentApiUserId
  }

  private get studentGradeCode() {
    return Vue.prototype.$cookies.get('dataGdls').grade.code
  }

  private get enableSelectedSubject() {
    return this.enableSubjects.includes(this.selectedSubject) ? this.selectedSubject : ''
  }

  // チャートデータ
  private chartDatas: ChartRecord[] = []

  // 学習結果
  private result = {
    questionCount: 0,
    correctCount: 0,
    hour: 0,
    minute: 0,
  }

  // 表示日付
  private dateSteps: string[] = []

  // 項目毎の累計理解度 rateの位置は最大値の位置で表示する
  private gradeHistories: GradeHistories[] = []

  private async mounted(): Promise<void> {
    Vue.prototype.$loading.start()
    await this.loadEnableSubjects()
    await this.loadChartRecords()
    await this.loadGradeHistories()
    Vue.prototype.$loading.complete()
  }

  // 期間プルダウン変更時
  private async onChangeTerm() {
    Vue.prototype.$loading.start()
    // チャート情報のみ取得
    await this.loadChartRecords()
    Vue.prototype.$loading.complete()
  }

  // 教科プルダウン変更時
  private async onChangeSubject() {
    Vue.prototype.$loading.start()
    // チャート情報と理解度リストどちらも取得
    await this.loadChartRecords()
    await this.loadGradeHistories()
    Vue.prototype.$loading.complete()
  }

  private addPropertyModecode(curriculums: GradeHistories[]) {
    if (this.isLerningPreview) {
      curriculums.forEach((curriculum) => {
        curriculum.histories.forEach((history: any) => {
          history.modeCode = this.modeCode
        })
      })
      return curriculums
    }
    return curriculums
  }

  /**
   * チャート情報取得
   */
  private async loadChartRecords() {
    if (this.selectedSubject == '') return
    const params: any = {
      userId: this.studentUserId,
      term: this.selectedTerm,
      subjectCode: this.selectedSubject,
    }
    if (this.modeCode) {
      params.classModeCode = this.modeCode
    }
    const { chartDatas, result, dateSteps } = await this.loadChartRecordsApi(params)
    // チャート用のスコア配列をセット
    this.chartDatas = chartDatas
    // 学習結果セット
    this.result = result
    // 表示日付セット
    this.dateSteps = dateSteps
  }

  /**
   * 項目毎の理解度取得
   */
  private async loadGradeHistories() {
    if (this.selectedSubject == '') return
    const params: any = {
      userId: this.studentUserId,
      subjectCode: this.selectedSubject
    }
    if (this.modeCode) {
      params.classModeCode = this.modeCode
    }
    const result = await this.loadGradeHistoriesApi(params)
    // 項目毎の累計理解度セット
    this.gradeHistories = this.addPropertyModecode(result['curriculums'])
  }

  /**
   * サービス設定で有効な教科を取得し、教科プルダウンに反映
   */
  private async loadEnableSubjects() {
    // プルダウン候補の取得
    this.enableSubjects = (await this.loadGdlsSubjectsApi(this.branchId, this.studentUserId)).map((subject) => {
      return subject.code
    })
    // デフォルトの教科セット
    this.selectedSubject = this.selectedSubject === '' ? this.enableSubjects[0] : this.selectedSubject
  }
}
